import axios, { AxiosError } from "axios"
import { LIST_PATH, MODULE_PATH } from "../../constants/paths"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"

const instance = axios.create({
  baseURL: process.env.REACT_APP_CREDENTIALS_API_SERVICE_DOMAIN,
})

instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const getModuleService = async () => {
  try {
    const result = await instance.get(MODULE_PATH + LIST_PATH)
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}

export const createModuleService = async (module: any) => {
  try {
    const result = await instance.post(MODULE_PATH, module)
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}

export const deleteModuleService = async (id: any) => {
  try {
    const result = await instance.delete(MODULE_PATH + `/${id}`)
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}

export const editModuleService = async (id: number, module: any) => {
  try {
    const result = await instance.put(MODULE_PATH + `/${id}`, module)
    return result.data
  } catch (error) {
    throw new Error((error as AxiosError)?.response?.data)
  }
}
